const userSelectors = {
  loading: state => state.userReducer.loading,
  users: state => state.userReducer.users,
};

export default userSelectors;